export enum BusinessHour {
    StartMorning = "08:00",
    EndMorning = "12:00",
    StartAfternoon = "13:00",
    EndAfternoon = "17:00"
}